import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
settingsMenu.$inject = ["ADMIN_URL", "$rootScope"];
angular.module('userApp').directive('settingsMenu', settingsMenu);

function settingsMenu(ADMIN_URL, $rootScope) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: ADMIN_URL + '/templates/directives/settings/settings-menu.html',
    scope: {},
    link: function () {
      var _link = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(scope, elem, attrs) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                scope.userIsOwner = $rootScope.userIsOwner;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function link(_x, _x2, _x3) {
        return _link.apply(this, arguments);
      };
    }()
  };
}